module.exports = __webpack_public_path__ + "img/new-zealand-flag.907bb5b6.png";